export {default} from './ProgressBar.connect';
